import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});

export * as Payments from './Payments';
